import { baseApi, createEndpointBuilder } from '@/shared/api';
import { API_TAGS } from '@/shared/api/tags';
import type { LayoutInitDTO, ContextDTO, BadgesDTO, PasswordChangeDTO } from '../model/types';

const layoutEndpoint = createEndpointBuilder('/api/v1/layout');

export const layoutApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    initLayout: builder.query<LayoutInitDTO, void>({
      query: () => layoutEndpoint('/init'),
      providesTags: [API_TAGS.LAYOUT]
    }),

    getContext: builder.query<ContextDTO, void>({
      query: () => layoutEndpoint('/context'),
      providesTags: [API_TAGS.LAYOUT]
    }),

    getBadges: builder.query<BadgesDTO, void>({
      query: () => layoutEndpoint('/badges'),
      providesTags: [API_TAGS.LAYOUT]
    }),

    changePassword: builder.mutation<void, PasswordChangeDTO>({
      query: (passwordData) => ({
        url: layoutEndpoint('/user/password'),
        method: 'PUT',
        body: passwordData
      })
    }),

    switchProject: builder.mutation<ContextDTO, number>({
      query: (projectId) => ({
        url: layoutEndpoint(`/context/project/${projectId}`),
        method: 'PUT'
      }),
      invalidatesTags: [API_TAGS.LAYOUT]
    }),

    switchSite: builder.mutation<ContextDTO, number>({
      query: (siteId) => ({
        url: layoutEndpoint(`/context/site/${siteId}`),
        method: 'PUT'
      }),
      invalidatesTags: [API_TAGS.LAYOUT]
    })
  })
});

export const {
  useInitLayoutQuery,
  useGetContextQuery,
  useGetBadgesQuery,
  useChangePasswordMutation,
  useSwitchProjectMutation,
  useSwitchSiteMutation,
  useLazyGetContextQuery,
  useLazyGetBadgesQuery
} = layoutApi;
